/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MissingInfoFollowUpList } from './MissingInfoFollowUpList';
import {
    MissingInfoFollowUpListFromJSON,
    MissingInfoFollowUpListFromJSONTyped,
    MissingInfoFollowUpListToJSON,
    MissingInfoFollowUpListToJSONTyped,
} from './MissingInfoFollowUpList';

/**
 * 
 * @export
 * @interface ListMissingInfoFollowUps200Response
 */
export interface ListMissingInfoFollowUps200Response {
    /**
     * 
     */
    data: MissingInfoFollowUpList;
}

/**
 * Check if a given object implements the ListMissingInfoFollowUps200Response interface.
 */
export function instanceOfListMissingInfoFollowUps200Response(value: object): value is ListMissingInfoFollowUps200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListMissingInfoFollowUps200ResponseFromJSON(json: any): ListMissingInfoFollowUps200Response {
    return ListMissingInfoFollowUps200ResponseFromJSONTyped(json, false);
}

export function ListMissingInfoFollowUps200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListMissingInfoFollowUps200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': MissingInfoFollowUpListFromJSON(json['data']),
    };
}

export function ListMissingInfoFollowUps200ResponseToJSON(json: any): ListMissingInfoFollowUps200Response {
    return ListMissingInfoFollowUps200ResponseToJSONTyped(json, false);
}

export function ListMissingInfoFollowUps200ResponseToJSONTyped(value?: ListMissingInfoFollowUps200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MissingInfoFollowUpListToJSON(value['data']),
    };
}

